module.exports = __webpack_public_path__ + "media/3.2423b900.wav";